import React from 'react';
import PropTypes from 'prop-types';

/**
 * Displays route header information
 * @param {Object} props
 * @param {string} props.vesselName - Name of the vessel
 * @param {string} props.date - Route date
 * @param {string} props.startTime - Start time
 * @param {string} props.endTime - End time
 */
const RouteInfoHeader = ({ vesselName, date, startTime, endTime }) => {
  return (
    <div className="route-info-header">
      <h2 className="vessel-name">{vesselName}</h2>
      <div className="route-metadata">
        <div className="metadata-item">
          <span className="metadata-label">Date</span>
          <span className="metadata-value">{new Date(date).toLocaleDateString()}</span>
        </div>
        <div className="metadata-item">
          <span className="metadata-label">Time Range</span>
          <span className="metadata-value">{startTime} - {endTime}</span>
        </div>
      </div>
    </div>
  );
};

RouteInfoHeader.propTypes = {
  vesselName: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
};

export default RouteInfoHeader;